import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel, trackCheckout } from '../data/offer';
const highlights = ['Premium Teaching Library', '5 Strategic Bonuses', 'Immediate Access'];
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden bg-navy-deep text-white" data-id="element-164" data-mp="4n1j0kwg00pc">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-navy via-navy-deep to-navy-deep -z-10" data-id="element-165" data-mp="1285x3nzc5smb" />
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-166" data-mp="sbb5lp1hcshj">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-167" data-mp="sd4bh249r8oh">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/50 bg-white/5 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-168" data-mp="3d2tpjcx5eqg4">
            🥋 Brazilian Jiu-Jitsu Instructor Ready
          </div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6" data-id="element-169" data-mp="3o7vgxbbup7t2">
            Solve an entire year of BJJ classes{' '}
            <span className="text-gold-light" data-id="element-170" data-mp="3e95ztkrs3rdv">in just 5 minutes</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[300px] sm:max-w-lg md:max-w-2xl mb-4 sm:mb-6" data-id="element-171" data-mp="30iaweo01u2ho">
          <div className="absolute inset-0 bg-gold/15 blur-[80px] rounded-full" data-id="element-172" data-mp="2qhqwpps6h61k" />
          <img src="https://cdn.magicpatterns.com/uploads/4MzkJGuo6cmoG8ghy2aaiH/Diseno_sin_titulo_(53).png" alt="Brazilian Jiu-Jitsu Instructor Ready — 100 ready-to-teach BJJ lessons, 4 volumes and 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-173" data-mp="2vj7tpa7jk8cv" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-174" data-mp="nbl58stuaue5">
          <p className="text-sm sm:text-lg md:text-xl text-white/85 leading-snug max-w-3xl mx-auto mb-5 sm:mb-7" data-id="element-175" data-mp="dd59gcjvawyb">
            <span className="font-semibold text-gold-light" data-id="element-176" data-mp="1b1fe6zb1fyt4">
              BJJ Instructor Ready
            </span>{' '}
            — 100 complete ready-to-teach Brazilian Jiu-Jitsu lessons, 4 volumes
            and 5 strategic bonuses
          </p>
          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-177" data-mp="110wq1scfxw5e">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-178" data-mp="x1wb4kx33dno">
              {ctaLabel}
            </Button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-white/70" data-id="element-179" data-mp="1xacfx49qzltr">
            {highlights.map(highlight => <div key={highlight} className="flex items-center gap-1.5" data-id="element-180" data-mp="218juptknid2b">
                <CheckCircleIcon size={14} className="text-forest-light" data-id="element-181" data-mp="268odxrcy1lw8" />
                <span data-id="element-182" data-mp="2b1r7w0lmuxcy">{highlight}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}